import Vue from 'vue'
import App from './App.vue'
import store from './store';
import router from './router/router';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import Http from './until/http';
import './scss/base.scss';
import './scss/iconfont.css';
import './scss/calculate/iconfont.css'
import vcolorpicker from 'vcolorpicker'
import vuescroll from "vuescroll";//引入vuescroll
import "vuescroll/dist/vuescroll.css";//引入vuescroll样式

// 高德地图 2.0 安全密钥（必须在任何 AMapLoader.load 之前设置，否则地图无法加载）
window._AMapSecurityConfig = {
	securityJsCode: 'a6c95f2d49553768ccd84ab100783147',
};

// 不再使用 vue-amap（1.4.4）。项目实际使用 @amap/amap-jsapi-loader 加载 2.0，
// 同页同时加载两个不同主版本会导致 AMapLoader.load 报
// "JSAPI is already loaded, Please do not load again." 错误，地图无法渲染。
// import VueAMap from 'vue-amap';
// Vue.use(VueAMap);
// VueAMap.initAMapApiLoader({
// 	key: '47579c505edaa2f1f85c4472c2eabfde',
// 	plugin: ['AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType','AMap.Geolocation','Geolocation','AMap.DistrictSearch'],
// 	uiVersion: '1.0',
// 	v: '1.4.4'
// });
Vue.use(vuescroll);//使用
Vue.use(vcolorpicker)
Vue.use(Antd);
Vue.config.productionTip = false
import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts;
Vue.prototype.$http=Http;
router.afterEach(() => {
	window.scrollTo(0,0);
});
new Vue({
	router,
	store,
	beforeCreate(){
		Vue.prototype.$bus = this
	},
	render: h => h(App),
}).$mount('#app')
